import { Component, HostListener, inject } from '@angular/core';
import { DynamicPageDcBaseComponent } from '../dynamic-page-dc-base/dynamic-page-dc-base.component';
import { CommonModalService, generateId } from 'gung-common';
import { CustomPageConfigService } from '../../../../../services/custom-page/custom-page-config.service';
import { firstValueFrom } from 'rxjs';
import { CdkDragDrop, moveItemInArray } from '@angular/cdk/drag-drop';

interface DynamicPageImageCarouselItem {
  image: string,
  link: string
}

@Component({
  selector: 'lib-dynamic-page-dc-image-carousel',
  standalone: false,
  templateUrl: './dynamic-page-dc-image-carousel.component.html',
  styleUrl: './dynamic-page-dc-image-carousel.component.scss'
})
export class DynamicPageDcImageCarouselComponent extends DynamicPageDcBaseComponent {
  protected customPagesService = inject(CustomPageConfigService);
  protected modalService = inject(CommonModalService);
  idUploadInput = generateId();
  imageUpload: File[];
  translate = false;

  elementId = 'image-carousel';
  fields = {
    imageCarouselItems: [{ image: '', link: '' }],
    marginTop: 0,
    marginRight: 0,
    marginBottom: 0,
    marginLeft: 0,
    paddingTop: 0,
    paddingRight: 0,
    paddingBottom: 0,
    paddingLeft: 0,
    height: 400,
    responsive: false
  };

  protected owlCarouselOptions = {
    stagePadding: 0,
    margin: 0,
    lazyLoad: true,
    loop: false,
    mouseDrag: false,
    touchDrag: false,
    pullDrag: false,
    dots: false,
    navSpeed: 700,
    navText: ['<i class="fas fa-arrow-left"></i>', '<i class="fas fa-arrow-right"></i>'],
    nav: true,
    autoWidth: false,
    items: 1,
    reponsive: {
      0: {
        items: 1
      }
    }
  };

  showCarousel: boolean = true;
  @HostListener('window:resize')
  onResize() {
    this.showCarousel = false;

    setTimeout(() => {
      this.showCarousel = true;
    }, 100);
  }


  uploadImage(index: number) {
    if (this.element.fields.imageCarouselItems?.[index]) {
      const item: DynamicPageImageCarouselItem = this.element.fields.imageCarouselItems[index];

      const fn = async (files: File[]) => {
        const imageObject = {
          index: 0,
          description: 'custompage image - ' + new Date().getTime(),
          category: 'custompage image',
          s3Uri: 'images/no-image.jpg'
        };
        const formData = new FormData();
        formData.append('file', files[0]);
        formData.append('productImage', JSON.stringify(imageObject));
        this.customPagesService.uploadImageS3(formData);
        return await firstValueFrom(this.customPagesService.uploadImageS3(formData));
      };

      this.modalService
        .openUploadModalComponent(fn, true, true, 'image/jpg, image/jpeg, image/png, image/webp', {
          translateTag: 'UPLOAD_IMAGE',
          class: 'mb-2 text-center'
        })
        .then(res => {
          if (res) {
            item.image = `https://cdn3.gung.io/${res.s3Uri}`;
          }
        });
    }
  }

  protected drop(event: CdkDragDrop<string[]>): void {
    moveItemInArray(this.element.fields.imageCarouselItems, event.previousIndex, event.currentIndex);
  }

  protected addCarouselItem(): void {
    this.element.fields.imageCarouselItems.push({ image: '', link: '' });
  }

  protected deleteCarouselItem(index: number): void {
    this.element.fields.imageCarouselItems.splice(index, 1);
  }
}
